<section class="dialog-title primary-background-gradient">
  <section class="grid-x align-justify align-middle">
    <div class="cell auto header-container">
      <div [ngClass]="{ wrapTitle: wrapTitle }">
        {{ dialogTitle }}
      </div>
    </div>

    <div class="cell shrink text-right" *ngIf="isCloseIconVisible">
      <button
        aria-label="Close"
        type="button"
        class="close-button"
        mat-icon-button
        [mat-dialog-close]="true"
      >
        <mat-icon class="close-icon" svgIcon="close"></mat-icon>
      </button>
    </div>
  </section>
</section>

<section class="dialog-content-container">
  <ng-content></ng-content>
</section>
